// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"696":"aa7ed8b47a9a70ba","2888":"ed9d883cbbb3ba33"}[chunkId] + ".css";
};